import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/homeData';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {t('category.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            {t('category.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 hover:bg-background-200/70 transition-all hover:scale-[1.02]"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${cat.color} transition-transform group-hover:scale-110`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800">{cat.name}</span>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            {t('category.viewAll')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}